import { XIcon } from "@foreday/ui/components/icons";
import { Kbd } from "@foreday/ui/components/kbd";
import { toastAction } from "@foreday/ui/components/toast";
import { Tip } from "@foreday/ui/components/tooltip";
import { Link } from "@tanstack/react-router";
import { clientCopy } from "@/client/copy";
import { glyph } from "@/client/lib/keyboard/glyphs";

const copy = clientCopy.toast;

/**
 * What a notice offers after its line: Retry, Undo with its key, a way to what it is about. Only a
 * failure waiting on Retry closes by hand; every other notice leaves on its own.
 */
export function NoticeActions({
  link,
  onRetry,
  retryLabel = copy.retry,
  onUndo,
  onClose,
}: {
  readonly link?: { readonly label: string; readonly to: string };
  readonly onRetry?: () => void;
  readonly retryLabel?: string;
  readonly onUndo?: () => void;
  readonly onClose?: () => void;
}) {
  return (
    <div className="flex items-center gap-2">
      {onRetry ? (
        <button type="button" onClick={onRetry} className={toastAction}>
          {retryLabel}
        </button>
      ) : null}
      {onUndo ? (
        <button
          type="button"
          aria-keyshortcuts="Meta+Z Control+Z"
          onClick={onUndo}
          className={`${toastAction} gap-2`}
        >
          {copy.undo}
          <span
            aria-hidden="true"
            className="flex gap-0.5 pointer-coarse:hidden"
          >
            <Kbd variant="keycap">{glyph("mod")}</Kbd>
            <Kbd variant="keycap">{copy.undoKey}</Kbd>
          </span>
        </button>
      ) : null}
      {link ? (
        <Link to={link.to} className={toastAction}>
          {link.label}
        </Link>
      ) : null}
      {onClose ? (
        <Tip label={copy.close}>
          <button
            type="button"
            aria-label={copy.close}
            onClick={onClose}
            className="inline-flex size-[var(--control-h-sm)] shrink-0 items-center justify-center rounded-full text-toast-foreground outline-none focus-visible:focus-ring"
          >
            <XIcon aria-hidden="true" className="size-[var(--icon-size)]" />
          </button>
        </Tip>
      ) : null}
    </div>
  );
}
